import { getIncentiveCampaignSSO } from './get-incentive-campaign-sso';

export const sso = {
  get: getIncentiveCampaignSSO,
};
